import * as Sentry from '@sentry/react';
import axios from 'axios';

import { config } from 'config/env';

export type SubscriptionPollingResponse = {
  status?: string;
};

function captureApiError(operation: string, error: unknown, extras: Record<string, unknown> = {}) {
  Sentry.withScope((scope) => {
    scope.setTag('area', 'upgrade_subscription');
    scope.setTag('flow', 'checkout_modal');
    scope.setTag('operation', operation);
    Object.entries(extras).forEach(([key, value]) => {
      scope.setExtra(key, value);
    });
    const sanitized = new Error(
      (error as { message?: string })?.message || 'Checkout API request failed',
    );
    sanitized.name = (error as { name?: string })?.name || 'Error';
    Sentry.captureException(sanitized);
  });
}

export async function fetchSubscriptionPollingStatus(
  subscriptionId: string,
  authToken: string,
  timeoutMs: number,
): Promise<SubscriptionPollingResponse> {
  try {
    const response = await axios.get(
      `${config.jusfyBackend.apiUrl}/subscription/polling/${subscriptionId}`,
      {
        headers: { Authorization: `Bearer ${authToken}` },
        timeout: timeoutMs,
      },
    );

    return response?.data ?? {};
  } catch (error) {
    captureApiError('fetchSubscriptionPollingStatus', error, { subscriptionId, timeoutMs });
    throw error;
  }
}
